import parse from "html-react-parser";
import { Link, useLocation } from "react-router-dom";
import { transformContent } from "../constants/GeneralConstants";
import React from "react";

export const languageCodes = ["zh-chs", "zh-cht", "ja", "ko", "fr-ca"];

const FormatText = ({ text }) => {
  const location = useLocation();

  if (typeof text !== "string") return null;

  let formattedText = "";
  try {
    formattedText = (transformContent(text) || "").replace(/\r\n/g, "<br>");
  } catch (err) {
    console.error("transformContent error:", err);
    formattedText = text;
  }

  const currentDomain = window.location.origin;

  const pathSegments = location.pathname.split("/");
  const firstSegment = pathSegments[1];

  const isLangPrefix = languageCodes.includes(firstSegment);
  const languagePrefix = isLangPrefix ? `/${firstSegment}` : "";

  const styleStringToObject = (styleString) => {
    return styleString
      .split(";")
      .filter(Boolean)
      .reduce((styleObj, style) => {
        const [key, value] = style.split(":").map((s) => s.trim());
        if (!key || !value) return styleObj;
        const camelCasedKey = key.replace(/-([a-z])/g, (_, char) =>
          char.toUpperCase()
        );
        styleObj[camelCasedKey] = value;
        return styleObj;
      }, {});
  };

  const createReactElement = (children) => {
    return children.map((child, index) => {
      if (child.data !== undefined) {
        return child.data;
      }

      if (child.name) {
        const {
          name: component,
          children: nestedChildren = [],
          attribs,
        } = child;

        const props = { ...attribs, key: index };

        if (attribs?.style) {
          props.style = styleStringToObject(attribs.style);
        }

        const nested = createReactElement(nestedChildren);
        return React.createElement(component, props, nested);
      }

      return null;
    });
  };

  const isExternal = (href) => {
    try {
      const url = new URL(href, currentDomain);
      const isSameDomain = url.origin === currentDomain;
      const isInternalPath = href.startsWith("/");
      const knownInternalDomains = [
        "ptw.com",
        "side.inc",
        "qaptwside.ptw",
        "entalize.co",
      ];
      const isKnownInternal = knownInternalDomains.some((domain) =>
        url.hostname.includes(domain)
      );
      return !(isSameDomain || isInternalPath || isKnownInternal);
    } catch {
      return false;
    }
  };

  const options = {
    replace: (domNode) => {
      if (domNode.name === "a" && domNode.attribs?.href) {
        let href = domNode.attribs.href;

        if (isExternal(href)) {
          return (
            <a href={href} target="_blank" rel="noopener noreferrer">
              {createReactElement(domNode.children)}
            </a>
          );
        }

        if (href.startsWith(currentDomain)) {
          href = href.replace(currentDomain, "");
        }

        if (href.startsWith("./")) {
          const basePath = location.pathname.substring(
            0,
            location.pathname.lastIndexOf("/")
          );
          href = `${basePath}/${href.substring(2)}`;
        }

        if (href.startsWith("/")) {
          const hrefSegments = href.split("/");
          const hrefFirstSegment = hrefSegments[1];

          if (languageCodes.includes(hrefFirstSegment)) {
            href = `/${hrefSegments.slice(2).join("/")}`;
          }

          href = `${languagePrefix}${href}`;
        }

        return <Link to={href}>{createReactElement(domNode.children)}</Link>;
      }

      return undefined;
    },
  };

  return <>{parse(formattedText, options)}</>;
};

export default FormatText;
